import React, { Component } from 'react';
import { withRouter } from 'react-router';
import ReactGA from 'react-ga';

import Stepper from '../Stepper/Stepper';
import StepTitle from '../StepTitle/StepTitle';
import Selector from '../Selector/Selector';
import PostalCodeArea from '../PostalCodeArea/PostalCodeArea';
import PostalCodeResult from '../PostalCodeResult/PostalCodeResult';
import Contact from '../Contact/Contact';
import NextButton from '../NextButton/NextButton';
import DotLine from '../DotLine';

class StepOne extends Component {
  componentDidMount() {
    if(process.env.PUBLIC_URL) {
      const pathname = `${process.env.PUBLIC_URL}`;
      ReactGA.pageview(pathname);
    }
  }

  render() {
    const stepNumber = 1;
    const title = 'お住まいのエリアと住居タイプをご選択ください。';
    const questionFirst = '住居タイプを教えてください。';
    const questionSecond = '';
    const optionsFirst = [ '一戸建て', '集合住宅' ];
    const optionsSecond = [ '持ち家', '賃貸' ];

    const {
      selectedFirst,
      selectedSecond,
      postalValueFirst,
      postalValueSecond,
      postalCode,
      postalInfo,
      dispatchSelectFirst,
      dispatchSelectSecond,
      dispatchSetPostalValueFirst,
      dispatchSetPostalValueSecond,
      dispatchSetPostalInfo,
      dispatchSetAreaCode,
    } = this.props;

    const handleNext = () => {
      dispatchSetAreaCode(postalInfo.areaCode);
      const pathname = `${process.env.PUBLIC_URL}/step2`;
      this.props.history.push(
        {
         pathname,
        }
      )
    }

    const validateForm = () => {
      return !selectedFirst.length || !postalInfo;
    }

    const onClickFirst = selectedIndex => {
      dispatchSelectFirst(selectedIndex);
    }

    const onClickSecond = selectedIndex => {
      dispatchSelectSecond(selectedIndex);
    }

    const handleCode = postalCode => {
      dispatchSetPostalInfo(postalCode);
    }

    const underArea = selectedFirst.indexOf(1) >= 0 ? <Contact /> : (
      <React.Fragment>
        <Selector
          title={questionSecond}
          options={optionsSecond}
          selected={selectedSecond}
          onClick={onClickSecond}
        />
        <DotLine />
        <PostalCodeArea
          handleCode={handleCode}
          handleValueFirst={dispatchSetPostalValueFirst}
          handleValueSecond={dispatchSetPostalValueSecond}
          postalValueFirst={postalValueFirst}
          postalValueSecond={postalValueSecond}
        />
        <DotLine />
        <PostalCodeResult
          postalInfo={postalInfo}
          invisible={!postalCode}
          // style={midStyle}
        />
        <NextButton
          onClick={handleNext}
          disable={validateForm()}
        />
      </React.Fragment>
    );

    return (
      <div id="container" className="container" >
        <Stepper activeNumber={stepNumber} />
        <StepTitle
          stepNumber={stepNumber}
          title={title}
        />
        <Selector
          title={questionFirst}
          options={optionsFirst}
          selected={selectedFirst}
          onClick={onClickFirst}
          must
          underDot
        />
        {underArea}
      </div>
    );
  }
};

export default withRouter(StepOne);
